import { Pipe, PipeTransform } from '@angular/core';
 

@Pipe({
  name: 'tonewlinehtml'
})
export class ToNewLineHTMLPipe implements PipeTransform {



    transform(value: string): string {
       
        return value.split('\n').join('<br/>');


    }

}
